import { createSelector } from '@reduxjs/toolkit';
import { selectStrategyAssociations } from '../../store/selectors';

export const selectAssociations = createSelector(selectStrategyAssociations, (listState) => listState.associations);
